import messages from './duplicar-modal-translations';
import * as $ from 'jquery';
import { DuplicarMapaService } from './services/duplicarMapaService';

export default {
    name: 'instamapsDuplicarModal',
    i18n: {
        messages,
    },
    data(){
        return {
            form: {
                nom: "",
            }
        };
    },
    props: {
        delay: { type: Number },
        isError: { type: Boolean },
        isLoaded: { type: Boolean },
        mapa: { type: Object },
    },
    methods: {
        show: function () {
            setTimeout(function () {
                $('#duplicar-modal-body').attr("style","display:block;");
                $('#duplicar-modal-msg').attr("style","display:none;");
                $('#duplicar-modal').addClass('animate-flex-modal');                
            }, (this.delay) ? this.delay : 100);
        },
        dismiss: function () {
            $('#duplicar-modal').removeClass('animate-flex-modal');
            this.$emit('loaded');
        },
        showMessageDuplicate: function(){
            $('#duplicar-modal-body').attr("style","display:none;");
            $('#duplicar-modal-msg').attr("style","display:block;");
        },
        duplicarMapa: function(){
            this.$validator.validateAll().then((result) => {
                if (result) {
                    this.showMessageDuplicate();
                    DuplicarMapaService.copyMap(this.mapa.businessId, this.form.nom).then((response) => {
                        if (response.status==="OK") {
                            this.$emit('copyMap', {businessId: response.results.businessId});
                            this.dismiss();
                        }else{
                            this.dismiss();
                            this.$emit('error', {title: this.$t('title'), message: this.$t('messageError')});
                        }
                    }).catch(() => {
                        this.dismiss();
                        this.$emit('error', {title: this.$t('title'), message: this.$t('messageError')});
                    });
                }
            });
        },
    },
    watch: {
        'isLoaded': function(val){
            if(val){
                this.show();
            }
        },
    },
};



// WEBPACK FOOTER //
// ./src/perfil/components/duplicar-modal/duplicar-modal.js